/** Build-only environment identity. Production has no override and keeps its origins. */
export interface MfpEnvironment {
  readonly id:string;
  readonly mode:'SANDBOX';
  readonly adminOrigin:string;
  readonly customerOrigin:string;
  readonly posOrigin:string;
}
declare const __MFP_ENVIRONMENT__:MfpEnvironment|undefined;

export function validateSandboxEnvironment(input:unknown):Readonly<MfpEnvironment>{
  const value=input as Partial<MfpEnvironment>|null;
  if(!value||value.mode!=='SANDBOX'||!/^mfp-sandbox-[a-z0-9-]+$/.test(value.id||''))throw Error('SANDBOX_ENVIRONMENT_REQUIRED');
  const origins=[value.adminOrigin,value.customerOrigin,value.posOrigin];
  for(const origin of origins){
    if(typeof origin!=='string')throw Error('SANDBOX_ORIGIN_REQUIRED');
    const url=new URL(origin);
    if(url.origin!==origin||url.protocol!=='https:'||!url.hostname.endsWith('.workers.dev')||!url.hostname.split('.')[0].includes('-sandbox'))throw Error('SANDBOX_ORIGIN_FORBIDDEN');
  }
  if(new Set(origins).size!==3)throw Error('SANDBOX_ORIGINS_MUST_BE_DISTINCT');
  return Object.freeze({...value}) as Readonly<MfpEnvironment>;
}

export const MFP_ENVIRONMENT:Readonly<MfpEnvironment>|null=typeof __MFP_ENVIRONMENT__==='undefined'?null:validateSandboxEnvironment(__MFP_ENVIRONMENT__);
export const mfpAdminOrigin=()=>MFP_ENVIRONMENT?.adminOrigin??'https://admin.morefunos.com';
export const mfpCustomerOrigin=()=>MFP_ENVIRONMENT?.customerOrigin??'https://order.morefunos.com';
export const mfpPosOrigin=()=>MFP_ENVIRONMENT?.posOrigin??'https://appassets.androidplatform.net';
export const mfpSmmOrigin=()=>MFP_ENVIRONMENT?.posOrigin??'https://smm.morefunos.com';
export const mfpOwnerOrigin=()=>MFP_ENVIRONMENT?.adminOrigin??'https://owner.morefunos.com';
export function mfpWebSocketUrl(origin:string,path:string){
  const url=new URL(path,origin);url.protocol=url.protocol==='https:'?'wss:':'ws:';return url.toString();
}
